export const LONG_POINTS = 'distribution-points-type/long-points';
export const SHORT_POINTS = 'distribution-points-type/short-points';
export const NONE = 'distribution-points-type/do-no';
